import MoveIcon from './svg/Move.svg';
import Tooltip from '@material-ui/core/Tooltip';

import { useContext, useCallback, useMemo } from 'react';


import { DragInterfaceContext } from './MouseDragProvider'; 
import { RowDragDispatch, RowDragState } from './RowDragProvider';




const imgStyle = {
  maxWidth:15,
  pointerEvents:'none',
}

export default function DragRowButton({

  //rowDragState,
  //rowDragDispatch,

  rowIndex,left, right,
  dragRowMargin,
  inDragRowState,
  tooltipPlacement
}){

  const outerStyle = useMemo(() => ({
    position:'absolute',
    top:'50%',
    transform:`translate(80%,-50%)`,
    zIndex:4000,
    cursor:'pointer',
    pointerEvents:(inDragRowState ? 'none':'auto'),
    textAlign:'center',
  }),[inDragRowState])

  const { startDrag } = useContext(DragInterfaceContext);

  const rowDragState = useContext(RowDragState);
  const rowDragDispatch = useContext(RowDragDispatch);



  //this is wrong, 
  //because we know
  //if it's left, it'll ALWAYS be left
  //and if it's right,
  //it'll ALWAYS be right
  const outerMoststyle = useMemo(() => ({
    position:'absolute', 
    height:'100%',
    left,
    right:-40,
    padding:0,
    margin:0,
    width:Math.max(40, Math.abs(left||right)),
    top:'50%',
    transform:'translate(0,-50%)',
    pointerEvents:(inDragRowState ? 'none':'auto'),
  }),[left,right, inDragRowState])


  const onMouseDown = useCallback(e => {


    startDrag({
      event:e,
      onDragEnd:(start,end,info) => {
        rowDragDispatch({
          release:true
        })
      }
    })


    rowDragDispatch({dragging:rowIndex})
  },[rowDragDispatch,startDrag,rowIndex])




  return (
    <Tooltip title={"Drag to Move Row"} placement={tooltipPlacement}>
      <div
        //style={{pointerEvents:'none'}}
        className={"invisible-without-grid-row-hover"}
        action={"start-drag-"+rowIndex}
        side={left?"left":"right"}

        style={
          outerMoststyle
          //{ pointerEvents:'none', }
        }>
        <div 
          class="no-drag"
          action={"rowDragButton"}
          rowIndex={rowIndex}
          side={left ? "left":"right"}
          onMouseDown={ onMouseDown }
          style={outerStyle}>
          <div>
            <img class="no-drag" alt="Drag row" style={imgStyle} src={MoveIcon}/>
          </div>
        </div>
      </div>
    </Tooltip>
  )
}
